import { ValidateRule } from '@/coreDomainsModule/constant/validateRules';

// リマインドメール設定関連の定数
export const REMINDER_MAIL_MEMO_MAX_LENGTH = 255;
// 発注グループ関連
export const OrderGroupMenuItems = {
  OrderGroupNew: 'orderGroupNew',
  OrderGroupAdd: 'orderGroupAdd',
  OrderGroupEdit: 'orderGroupEdit',
  OrderGroupDelete: 'orderGroupDelete',
} as const;
/**
 * OrderGroupMenuItemsの型
 */
export type OrderGroupMenuItems = (typeof OrderGroupMenuItems)[keyof typeof OrderGroupMenuItems];

export const OrderGroupAdditionalModalState = {
  None: 'none',
  OrderGroupInfoEdit: 'orderGroupInfoEdit',
} as const;
/**
 * OrderGroupAdditionalModalStateの型
 */
export type OrderGroupAdditionalModalState = (typeof OrderGroupAdditionalModalState)[keyof typeof OrderGroupAdditionalModalState];

export const OrderGroupModalState = { ...OrderGroupMenuItems, ...OrderGroupAdditionalModalState };
/**
 * OrderGroupModalStateの型
 */
export type OrderGroupModalState = (typeof OrderGroupModalState)[keyof typeof OrderGroupModalState];

export const ORDER_GROUP_MODIFY_KEYS: Array<[string, Array<string>]> = [
  ['orderGroupName', [ValidateRule.Required]],
  ['invoiceNumber', []],
  ['destinationName', []],
  ['upperLimitQuantity', [ValidateRule.Required, ValidateRule.HalfWidthRealNumber]],
];
export const ORDER_GROUP_MENU_HEIGHT = 40;
export const FIRM_ORDER_TABLE_TYPE = 'firmOrderTable';
export const ORDER_MANAGE_TABLE_TYPE = 'orderManageTable';

// NJP輸入書式のシート名
export const NJP_IMPORT_SHEET_NAME = 'importContractInformation';

export const BulkEditOrderMenuItemValues = ['status', 'eta'] as const;
/**
 * 一括編集メニューアイテムの型
 */
export type BulkEditOrderMenuItemValues = (typeof BulkEditOrderMenuItemValues)[number];

export const BULK_EDIT_ORDER_MENU_ITEMS = [
  { label: 'ステータスを編集', value: 'status' },
  { label: '納期を編集', value: 'eta' },
] satisfies { label: string; value: BulkEditOrderMenuItemValues }[];
